/** 키오스크가 보내는 타입. 서버 수집 라우트는 이 목록만 받는다. */
export const KIOSK_ACTIVITY_TYPES = [
    /** 어트랙트를 떠남 = 방문 시작. 새 visitId. */
    "visit_start",
    /** 화면 전환 — `route` = 들어간 화면, `from` = 떠난 화면, `durationMs` = 떠난 화면에 머문 시간 */
    "screen",
    "language_set",
    /** 카운트다운 시작(촬영 버튼) */
    "capture_countdown",
    /** 셔터 — 정지 사진 확인 화면으로 */
    "capture_taken",
    /** 확인 화면에서 다시 찍기 */
    "capture_retake",
    /** 방문 종료 — `reason` */
    "visit_end",
    /**
     * 전역 오류/거부 처리, ErrorBoundary, 실패 지점에서 명시 호출 (BOOTH-97).
     * `code`(ClientErrorCode) · `message`(≤200자, 정제 후) · `route` · `visitId?`
     */
    "client_error",
    /**
     * 페이지 로드/새로고침, slug 가 정해진 직후 1회 (BOOTH-97).
     * `appVersion` · `userAgent`(≤200) · `viewport`(`WxH`) · `language` · `deviceTimeZone`(기기 IANA 시간대, BOOTH-78)
     * 서버는 activity 에 저장하고 동시에 `Booth.kiosk` 에 미러한다.
     */
    "kiosk_boot",
    /** `navigator.onLine` true→false (BOOTH-97). `route` · `visitId?` */
    "kiosk_offline",
    /**
     * false→true (BOOTH-97). `durationMs` = 오프라인 지속 ms.
     * 서버는 activity 에 저장한다.
     */
    "kiosk_online",
    /**
     * 화면과 무관하게 20초마다 (BOOTH-97).
     * **activity 테이블에 저장하지 않고 `Booth.kiosk` UpdateItem 으로만 처리한다.**
     * `route` · `appVersion` · `deviceTimeZone`(값이 바뀌면 스로틀과 무관하게 즉시 미러, BOOTH-78)
     */
    "kiosk_heartbeat",
];
/** 서버가 결과 지점에서 기록하는 타입. */
export const SERVER_ACTIVITY_TYPES = [
    "session_created",
    "session_uploaded",
    "transform_success",
    "transform_error",
    "video_start",
    "video_success",
    "video_error",
    "payment_paid",
    "payment_refunded",
    "print_printed",
    "print_failed",
    /**
     * 세션·영상·결제·인쇄 공개 라우트가 4xx·503 으로 거부한 요청 (BOOTH-97).
     * `code`(응답 error.code) · `httpStatus` · `path`(≤80) · `visitId?` · `paymentId?` · `shortCode?` · `jobId?`
     * 본문 파싱 실패(INVALID_INPUT)와 부스 404 는 기록하지 않는다.
     */
    "request_rejected",
    /**
     * 변환 재시도 진행 (BOOTH-109). `attempt`(다음 시도 번호) · `code`(사유 `http_503`·`http_429`) · `jobId`.
     * 그룹 `server` — 실패가 아니라 진행 기록이라 오류 KPI 에 넣지 않는다.
     */
    "transform_retry",
    /**
     * 영상 후처리(ffmpeg 자막·음악·워터마크) 실패 (BOOTH-109). 원본 mp4 는 그대로 전달됐으므로 **경고** — 그룹 `server`,
     * 오류 KPI·`kioskNow` 영상 상태에 영향 없음. `code` = `VIDEO_POSTPROCESS_FAILED`, 상세는 activity-errors 테이블.
     */
    "video_postprocess_failed",
    /**
     * 콘솔이 부스 시간대(`Booth.timeZone`)를 바꿨다 (BOOTH-78). `prevTimeZone` → `timeZone`(둘 다 해석된 IANA, 미설정 = Asia/Seoul) ·
     * `actor`(매니저 계정). 그룹 `server` — 설정 변경 기록이라 오류 KPI·퍼널 집계에서 제외. 값이 같으면 기록하지 않는다.
     */
    "booth_timezone_changed",
    /**
     * 운영 마감 처리 (BOOTH-122). `actor` = `console:<username>` | `agent:<agentId>`.
     * 그룹 `server` — 설정 변경 기록이라 오류 KPI·퍼널 집계에서 제외.
     */
    "booth_closed",
    /**
     * 부스 보관 처리 (BOOTH-127). `actor` = `console:<username>`.
     * 그룹 `server` — 보관/복구 설정 변경 기록이라 오류 KPI·퍼널 집계에서 제외.
     */
    "booth_archived",
    /**
     * 부스 보관 복구 처리 (BOOTH-127). `actor` = `console:<username>`.
     * 그룹 `server` — 보관/복구 설정 변경 기록이라 오류 KPI·퍼널 집계에서 제외.
     */
    "booth_restored",
    /** AI 호출 추적 — 콘솔 테스트를 포함한다. 손님 퍼널·오류 KPI 와 별도로 조회한다. */
    "ai_call_started",
    "ai_call_succeeded",
    "ai_call_failed",
];
/**
 * 방문 종료 이유 — thanks: 완료 화면까지 감 · idle: 무동작 타임아웃 · home: 손님이 "처음으로" ·
 * reset: 그 외 세션 리셋(오류 복귀 등) · declined: 손님이 동의 화면에서 거부(BOOTH-66).
 */
export const VISIT_END_REASONS = ["thanks", "idle", "home", "reset", "declined"];
/** 한 요청에 담을 수 있는 최대 이벤트 수 (키오스크 flush 상한과 서버 검증이 공유). */
export const ACTIVITY_BATCH_MAX = 50;
// ─── BOOTH-97 상수 ────────────────────────────────────────────────────────────
/** 키오스크 하트비트 전송 간격 ms (20초). 부스당 하루 최대 4,320건 UpdateItem. */
export const HEARTBEAT_INTERVAL_MS = 20_000;
/** 마지막 신호 뒤 이 시간(60초)이 지나면 키오스크를 "응답 없음" 으로 간주. */
export const KIOSK_OFFLINE_AFTER_MS = 60_000;
/** 마지막 신호 뒤 이 시간(60분)이 지나면 키오스크를 "꺼짐(off)" 으로 간주(disconnected → off, BOOTH-122). */
export const KIOSK_OFF_AFTER_MS = 60 * 60_000;
/** 운영 마감 처리 뒤 이 시간(5분) 이내 신호는 마감 이전 것으로 간주 (끊김 지연 여유, BOOTH-122). */
export const KIOSK_CLOSE_GRACE_MS = 5 * 60_000;
/** 오류 메시지 최대 길이 (문자). 사진·dataURL 정제 후 절단. */
export const ERROR_MESSAGE_MAX = 200;
/** 끝 이벤트 없는 방문을 종료로 간주할 경과 시간 ms (60분). 무동작 idle 리셋 유실 대비. */
export const VISIT_STALE_MS = 3_600_000;
/** thanks 화면 자동 복귀(30초) 여유를 포함한 정착 시간 ms (60초). route 복원 규칙에서 사용. */
export const THANKS_SETTLE_MS = 60_000;
/** `/now` 가 읽는 최대 활동 이벤트 수. */
export const KIOSK_NOW_EVENT_LIMIT = 400;
export const ACTIVITY_GROUPS = ["error", "status", "guest", "server", "ai"];
/**
 * 타입을 그룹으로 매핑한다. 전수 switch — `default` 의 `never` 할당으로 누락을 컴파일 타임에 잡는다.
 * `default` 는 동시에 런타임 폴백이기도 하다 — 옛 배포가 남긴, 지금 타입에 없는 저장값이 와도 "server" 로 떨어져
 * 콘솔 표가 `undefined` 그룹으로 깨지지 않는다.
 */
export function activityGroup(type) {
    switch (type) {
        // AI 호출은 손님 오류 KPI 와 분리한다. 콘솔 오류 필터는 ai_call_failed 를 별도로 포함한다.
        case "ai_call_started":
        case "ai_call_succeeded":
        case "ai_call_failed":
            return "ai";
        // error
        case "client_error":
        case "request_rejected":
        case "transform_error":
        case "video_error":
        case "print_failed":
            return "error";
        // status
        case "kiosk_boot":
        case "kiosk_online":
        case "kiosk_offline":
        case "kiosk_heartbeat":
            return "status";
        // guest
        case "visit_start":
        case "screen":
        case "language_set":
        case "capture_countdown":
        case "capture_taken":
        case "capture_retake":
        case "visit_end":
            return "guest";
        // server
        case "session_created":
        case "session_uploaded":
        case "transform_success":
        case "video_start":
        case "video_success":
        case "payment_paid":
        case "payment_refunded":
        case "print_printed":
        case "transform_retry":
        case "video_postprocess_failed":
        case "booth_timezone_changed":
        case "booth_closed":
        case "booth_archived":
        case "booth_restored":
            return "server";
        default: {
            // 컴파일 타임 전수 검사 — 새 타입을 추가하면 여기서 타입 오류가 난다.
            const _exhaustive = type;
            void _exhaustive;
            return "server";
        }
    }
}
/** 오류 그룹에 속하는 타입 목록 (콘솔 필터·통계 KPI 공용). */
export const ERROR_ACTIVITY_TYPES = [
    "client_error",
    "request_rejected",
    "transform_error",
    "video_error",
    "print_failed",
];
// ─── 클라이언트 오류 코드 ─────────────────────────────────────────────────────
/**
 * 클라이언트 오류 코드 형식 정규식 (`^[a-z][a-z0-9_]{1,40}$`).
 * 서버는 이 형식만 검사해 코드 추가가 서버 배포를 요구하지 않게 한다.
 */
export const CLIENT_ERROR_CODE_RE = /^[a-z][a-z0-9_]{1,40}$/;
/**
 * 키오스크가 사용하는 오류 코드 목록.
 * 서버는 형식(CLIENT_ERROR_CODE_RE)만 검사 — 이 목록은 키오스크·콘솔 UI 참조용.
 */
export const CLIENT_ERROR_CODES = [
    "camera_denied",
    "camera_unavailable",
    "upload_failed",
    "upload_confirm_failed",
    "session_create_failed",
    "session_rejected",
    "transform_failed",
    "video_start_failed",
    "video_poll_failed",
    "payment_create_failed",
    "payment_poll_failed",
    "payment_cancel_failed",
    "print_request_failed",
    "print_poll_failed",
    "window_print_failed",
    "share_print_failed",
    "qr_render_failed",
    "fit_image_failed",
    "watermark_load_failed",
    "config_refresh_failed",
    "render_crash",
    "unhandled_error",
    "unhandled_rejection",
];
// ─── 기존 헬퍼 ────────────────────────────────────────────────────────────────
export function isKioskActivityType(v) {
    return typeof v === "string" && KIOSK_ACTIVITY_TYPES.includes(v);
}
export function isVisitEndReason(v) {
    return typeof v === "string" && VISIT_END_REASONS.includes(v);
}
/** 키오스크 현재 상태 조회용 — AI 호출이 최근 이벤트 상한을 차지하지 않도록 DB 조회 전에 필터한다. */
export const OPERATIONAL_ACTIVITY_TYPES = [
    ...KIOSK_ACTIVITY_TYPES,
    ...SERVER_ACTIVITY_TYPES,
].filter((type) => activityGroup(type) !== "ai");
//# sourceMappingURL=activity.js.map